<template>
  <section :class="['category-section', { 'is-flat': !overlap }]">
    <div class="core-container category-section__shell">
      <div class="category-panel">
        <aside class="category-panel__sidebar">
          <h2 class="category-panel__sidebar-title">找商标</h2>
          <p class="category-panel__sidebar-desc">海量商标任你选</p>
          <button
            type="button"
            class="category-panel__sidebar-btn"
            @click="onShowAllCategories"
          >
            <span class="category-panel__sidebar-btn-icon">☰</span>
            全部类别
          </button>
        </aside>

        <div class="category-panel__grid">
          <button
            v-for="cat in categories"
            :key="cat.id"
            type="button"
            :class="[
              'category-item',
              { 'is-active': String(activeCategoryId) === String(cat.id) }
            ]"
            @click="onCategoryClick(cat)"
          >
            <img
              :src="cat.icon"
              :alt="cat.name"
              class="category-item__icon"
            />
            <span class="category-item__label">
              <span class="category-item__id">{{ formatId(cat.id) }}</span>
              {{ cat.name }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { HOT_CATEGORIES } from '@/constants/categories'

export default {
  name: 'CategoryNav',
  props: {
    activeCategoryId: {
      type: [String, Number],
      default: ''
    },
    overlap: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      categories: HOT_CATEGORIES
    }
  },
  methods: {
    formatId(id) {
      return String(id).padStart(2, '0')
    },
    onCategoryClick(cat) {
      this.$emit('select', cat)
    },
    onShowAllCategories() {
      this.$emit('show-all')
    }
  }
}
</script>

<style scoped>
.category-section {
  position: relative;
  z-index: 2;
  margin-top: calc(-1 * var(--banner-safe-bottom));
  padding-bottom: var(--space-lg);
}

.category-section.is-flat {
  margin-top: calc(-1 * var(--banner-safe-bottom));
}

.category-section__shell {
  transform: translateY(calc(-1 * var(--category-panel-lift)));
}

.category-panel {
  display: flex;
  min-height: var(--category-panel-min-height);
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
  overflow: hidden;
}

.category-panel__sidebar {
  width: var(--sidebar-width);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl) var(--space-md);
  background: var(--color-bg-section);
  border-right: 1px solid var(--color-border-light);
}

.category-panel__sidebar-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--color-text-primary);
}

.category-panel__sidebar-desc {
  margin-top: var(--space-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  text-align: center;
}

.category-panel__sidebar-btn {
  margin-top: var(--space-lg);
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm) var(--space-lg);
  background: var(--color-primary);
  color: var(--color-text-inverse);
  border: none;
  border-radius: var(--radius-pill);
  font-size: var(--font-size-md);
}

.category-panel__sidebar-btn:hover {
  background: var(--color-primary-dark);
}

.category-panel__sidebar-btn-icon {
  font-size: var(--font-size-lg);
  line-height: 1;
}

.category-panel__grid {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(var(--grid-columns-category), minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(var(--category-item-min-height), 1fr));
  gap: var(--category-grid-row-gap) var(--category-grid-column-gap);
  padding: var(--space-md);
  align-content: stretch;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: var(--category-item-min-height);
  padding: var(--space-sm) var(--space-xs);
  border: none;
  background: transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background-color 0.2s;
}

.category-item:hover,
.category-item.is-active {
  background: var(--color-bg-section);
}

.category-item.is-active .category-item__label,
.category-item.is-active .category-item__id {
  color: var(--color-primary);
}

.category-item__icon {
  width: var(--category-icon-size);
  height: var(--category-icon-size);
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.category-item__label {
  font-size: var(--category-label-size);
  color: var(--color-text-secondary);
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
}

.category-item__id {
  font-weight: 600;
  color: var(--color-text-primary);
  margin-right: var(--space-xs);
}
</style>
